export default "__VITE_ASSET__36088c42__"